import { app } from '../app';

class FederateSsoResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    federateSso(companyId, appId, credentials) {
        const url = `app/rest/admin/company/${companyId}/application/${appId}/manageapp/federatesso`;
        return this.$http.post(url, credentials).then(({data}) => data);
    }
}

app.service('FederateSsoResource', FederateSsoResource);



// WEBPACK FOOTER //
// ./src/portal/rest/FederateSsoResource.js